import React from 'react'
import _ from 'lodash'
import {SortableList, indexId, Popup, Card, Alert, Button, IconButton, Modal, ModalHeader, ModalActions, S1, S2} from '../../UI/index.js'
import askToSaveChanges from '../../UI/overlays/askToSaveChanges.js'
import CarrierSelector from '../../parcels/CarrierSelector.js'
import {formSpacing, FormStack, Input, Select, CurrencyInput, Toggle} from '../../UI/forms/index.js'
import PriceRuleModal from './PriceRuleModal.js'
import CategoryModal from './CategoryModal.js'
import PriceScaleModal, {PriceScaleModalRef} from './PriceScaleModal.js'
import Countries from '../../../utils/Countries.js'
import type {ParcelProducts, ParcelPriceTable, ParcelPriceRule, Reseller} from '../../../../types/types.js'
import type {ParcelCarrier} from '../../../../server/functions/parcels/carrier.types.js'

interface PriceTableModalProps {
    carriers: ParcelCarrier[]
    reseller: Reseller
    copiedPriceTable?: any
    onClickCopyCarrierPriceTable: (priceTable?: any, carrier?: ParcelCarrier) => void
    onRemove: (name: string) => void
    onAdd: (name: string, priceTable: ParcelPriceTable) => void
    onChange: (name: string, oldName: string, priceTable: ParcelPriceTable) => void
}

interface PriceTableModalState {
    open: boolean
    name: string
    oldName: string
    priceTable: ParcelPriceTable
    selectedCarrier?: ParcelCarrier
    selectedPriceTable: string
    error: string
    initialPriceTable?: ParcelPriceTable
}

class PriceTableModal extends React.Component<PriceTableModalProps, PriceTableModalState> {
    initialState: PriceTableModalState
    popup: any
    PriceRuleModal: any
    categoryModal: any
    priceScaleModal: React.RefObject<PriceScaleModalRef>

    constructor(props: PriceTableModalProps) {
        super(props)
        this.priceScaleModal = React.createRef<PriceScaleModalRef>()
        this.initialState = {
            open: false,
            name: '',
            oldName: '',
            priceTable: {},
            selectedCarrier: props.carriers[0],
            selectedPriceTable: 'Standaard',
            error: ''
        }

        this.state = this.initialState
    }

    open(name: string, oldName: string, priceTable: ParcelPriceTable) {
        this.setState({open: true, name, oldName, priceTable, initialPriceTable: priceTable})
    }

    async close(showWarning?: boolean) {
        if (showWarning) {
            const choice = await askToSaveChanges(this.popup)

            if (choice === 'save') {
                this.onSubmit()
            } else if (choice === 'dontSave') {
                this.setState(this.initialState)
            }
        } else {
            this.setState(this.initialState)
        }
    }

    onChangeName(event: React.ChangeEvent<HTMLInputElement>) {
        if (!event.target.value.includes('.')) {
            this.setState({name: event.target.value})
        }
    }

    onClickPasteCarrierPriceTable(carrier: ParcelCarrier) {
        const {priceTable} = this.state
        const {copiedPriceTable, onClickCopyCarrierPriceTable} = this.props

        priceTable[carrier.name] = copiedPriceTable

        this.setState({priceTable})

        onClickCopyCarrierPriceTable()
    }

    onChangeCarrier(event: React.ChangeEvent<HTMLInputElement>) {
        const {carriers} = this.props

        const selectedCarrier = _.find(carriers, {name: event.target.value})

        this.setState({selectedCarrier})
    }

    onEditPriceRule(carrier: ParcelCarrier, product: ParcelProducts, index: number, priceRule: ParcelPriceRule) {
        const {priceTable} = this.state

        priceTable[carrier.name][product].countryGroups[index] = priceRule

        this.setState({priceTable})
    }

    onRemovePriceRule(carrier: ParcelCarrier, product: ParcelProducts, index: number) {
        const {priceTable} = this.state

        priceTable[carrier.name][product].countryGroups.splice(index, 1)

        this.setState({priceTable})
    }

    onClickOpenPriceRuleModal(carrier: ParcelCarrier, product: ParcelProducts, index: number, priceRule: ParcelPriceRule) {
        const {priceTable} = this.state
        let countries = [...carrier.countries]

        if (product !== 'Standaard zending') {
            product.split(', ').map((product) => {
                countries = _.intersection(countries, carrier.products[product].countries)
            })
        }

        if (countries.length > 1) {
            countries.push('Overige')
        }

        const usedCountries = []
        priceTable[carrier.name][product].countryGroups.map((priceRule) => {
            usedCountries.push(...priceRule.countries)
        })
        countries = _.uniq(_.difference(countries, usedCountries))
        countries.push(...priceRule.countries)

        countries.sort((a, b) => {
            const countryA = _.find(Countries, {code2: a}) || {code2: a, name: a}
            const countryB = _.find(Countries, {code2: b}) || {code2: b, name: b}
            return countryA.name.localeCompare(countryB.name)
        })
        const otherIndex = countries.indexOf('Overige')
        if (otherIndex > -1) {
            countries.splice(otherIndex, 1)
            countries.push('Overige')
        }

        this.PriceRuleModal.open(carrier, product, index, priceRule, countries)
    }

    onSortPricesRules(carrier: ParcelCarrier, product: ParcelProducts, priceRules: ParcelPriceRule[]) {
        const {priceTable} = this.state

        priceTable[carrier.name][product].countryGroups = priceRules

        this.setState({priceTable})
    }

    onClickAddPriceRule(carrier: ParcelCarrier, product: any, productName: ParcelProducts) {
        const {priceTable} = this.state

        const priceRule: ParcelPriceRule = {
            name: '',
            countries: [],
            type: product.type === 'product' ? 'weight' : 'fee',
            price: '0,00',
            fee: '0,00',
            categories: [
                {
                    name: '',
                    price: '0,00',
                    maxWeight: '2',
                    length: 0,
                    width: 0,
                    height: 0,
                    volume: 0,
                    productCode: '',
                    priceScales: [{
                        price: '0,00'
                    }]
                },
                {
                    name: '',
                    price: '0,00',
                    maxWeight: '5',
                    length: 0,
                    width: 0,
                    height: 0,
                    volume: 0,
                    productCode: '',
                    priceScales: [{
                        price: '0,00'
                    }]
                },
                {
                    name: '',
                    price: '0,00',
                    maxWeight: '10',
                    length: 0,
                    width: 0,
                    height: 0,
                    volume: 0,
                    productCode: '',
                    priceScales: [{
                        price: '0,00'
                    }]
                },
                {
                    name: '',
                    price: '0,00',
                    maxWeight: '20',
                    length: 0,
                    width: 0,
                    height: 0,
                    volume: 0,
                    productCode: '',
                    priceScales: [{
                        price: '0,00'
                    }]
                },
                {
                    name: '',
                    price: '0,00',
                    maxWeight: '31,5',
                    length: 0,
                    width: 0,
                    height: 0,
                    volume: 0,
                    productCode: '',
                    priceScales: [{
                        price: '0,00'
                    }]
                }
            ],
            values: {},
            priceScales: [{
                price: '0,00'
            }]
        }

        // TODO fix typescript error, move countrygroups/pricerules to a separate object
        priceTable[carrier.name] = priceTable[carrier.name] || {usePriceScales: false}
        priceTable[carrier.name][productName] = priceTable[carrier.name][productName] || {usePriceScales: false, countryGroups: []}
        priceTable[carrier.name][productName].countryGroups = priceTable[carrier.name][productName].countryGroups || []
        priceTable[carrier.name][productName].countryGroups.push(priceRule)

        this.setState({priceTable})

        this.onClickOpenPriceRuleModal(carrier, productName, priceTable[carrier.name][productName].countryGroups.length - 1, priceRule)
    }

    onChangeType(carrier: ParcelCarrier, product: ParcelProducts, priceRuleIndex: number, event: React.ChangeEvent<HTMLSelectElement>) {
        const {priceTable} = this.state

        priceTable[carrier.name][product].countryGroups[priceRuleIndex].type = event.target.value as ParcelPriceRule['type']

        this.setState({priceTable})
    }

    onChangePrice(carrier: ParcelCarrier, product: ParcelProducts, priceRuleIndex: number, value: number | null, event: React.ChangeEvent<HTMLInputElement>) {
        const {priceTable} = this.state

        if (/^$|^[-]{0,1}[0-9]{0,4}$|^[-]{0,1}[0-9]{0,4}[,][0-9]{0,2}$/.test(event.target.value)) {
            if (value) {
                priceTable[carrier.name][product].countryGroups[priceRuleIndex].values[value] = event.target.value
            } else {
                priceTable[carrier.name][product].countryGroups[priceRuleIndex].price = event.target.value
            }

            this.setState({priceTable})
        }
    }

    onClickAddCategory(carrier: ParcelCarrier, product: ParcelProducts, priceRuleIndex: number) {
        const {priceTable} = this.state

        priceTable[carrier.name][product].countryGroups[priceRuleIndex].categories.push({
            name: '',
            maxWeight: '0',
            length: 0,
            width: 0,
            height: 0,
            volume: 0,
            price: '0,00',
            fee: '0',
            priceScales: [{
                price: '0,00'
            }]
        })

        this.setState({priceTable})
    }

    onClickOpenCategoryModal(carrier: ParcelCarrier, product: ParcelProducts, priceRuleIndex: number, index: number, category: ParcelPriceRule['categories'][0]) {
        this.categoryModal.open(carrier, product, priceRuleIndex, index, category)
    }

    onEditCategory(carrier: ParcelCarrier, product: ParcelProducts, priceRuleIndex: number, index: number, category: ParcelPriceRule['categories'][0]) {
        const {priceTable} = this.state

        priceTable[carrier.name][product].countryGroups[priceRuleIndex].categories[index] = category

        this.setState({priceTable})
    }

    onRemoveCategory(carrier: ParcelCarrier, product: ParcelProducts, priceRuleIndex: number, index: number) {
        const {priceTable} = this.state

        priceTable[carrier.name][product].countryGroups[priceRuleIndex].categories.splice(index, 1)

        this.setState({priceTable})
    }

    onChangeCategoryPrice(carrier: ParcelCarrier, product: ParcelProducts, ParcelCarrier: number, category: number, event: React.ChangeEvent<HTMLInputElement>) {
        const {priceTable} = this.state

        if (/^$|^[-]{0,1}[0-9]{0,4}$|^[-]{0,1}[0-9]{0,4}[,][0-9]{0,2}$/.test(event.target.value)) {
            priceTable[carrier.name][product].countryGroups[ParcelCarrier].categories[category].price = event.target.value

            this.setState({priceTable})
        }
    }

    onChangeFee(carrier: ParcelCarrier, product: ParcelProducts, priceRuleIndex: number, event: React.ChangeEvent<HTMLInputElement>) {
        const {priceTable} = this.state

        if (/^$|^[-]{0,1}[0-9]{0,4}$|^[-]{0,1}[0-9]{0,4}[,][0-9]{0,2}$/.test(event.target.value)) {
            priceTable[carrier.name][product].countryGroups[priceRuleIndex].fee = event.target.value

            this.setState({priceTable})
        }
    }

    onChangeRound(carrier: ParcelCarrier, product: ParcelProducts, priceRuleIndex: number, event: React.ChangeEvent<HTMLSelectElement>) {
        const {priceTable} = this.state

        priceTable[carrier.name][product].countryGroups[priceRuleIndex].round = event.target.value

        this.setState({priceTable})
    }

    onRemove() {
        const {oldName} = this.state
        const {onRemove} = this.props

        this.popup.open('Tarieftabel verwijderen', 'Weet je zeker dat je deze tarieftabel wilt verwijderen?', () => {
            onRemove(oldName)
            this.close()
        })
    }

    onSubmit() {
        const {name, oldName, priceTable} = this.state
        const {onAdd, onChange} = this.props

        if (oldName) {
            onChange(name, oldName, priceTable)
        } else {
            onAdd(name, priceTable)
        }
        this.close()
    }

    render() {
        const {open, name, oldName, selectedCarrier, priceTable, error} = this.state
        const {carriers, reseller, copiedPriceTable, onClickCopyCarrierPriceTable} = this.props

        const enabledCarriers = _.filter(carriers, (carrier) => {
            return reseller.settings.parcels.carriers[carrier.name] && reseller.settings.parcels.carriers[carrier.name].enabled
        })

        let selectedCarrierProducts = []

        if (selectedCarrier && selectedCarrier.products) {
            selectedCarrierProducts = [
                'Standaard zending',
                ..._.keys(selectedCarrier.products).sort()
            ]
        }

        return (
            <Modal style={{width: 'fit-content', minWidth: '95%', maxWidth: '95%', overflowX: 'auto'}} show={open} onClose={this.close.bind(this, true)}>
                <ModalHeader title={`${oldName ? 'Wijzig' : 'Nieuwe'} tarieftabel`} onClose={this.close.bind(this, true)} style={{marginBottom: 0}} />

                <FormStack>
                    <Input
                        label='Naam'
                        value={name}
                        onChange={this.onChangeName.bind(this)}
                        style={{maxWidth: 400}}
                        disabled={name === 'Standaard'}
                    />

                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <div style={{display: 'flex', width: 330, height: 40}}>
                            <IconButton
                                disabled={!selectedCarrier.name}
                                tooltip='Kopieer vervoerder tarieven'
                                onClick={() => onClickCopyCarrierPriceTable(priceTable, selectedCarrier)}
                            >
                                <i className='mdi mdi-content-copy' />
                            </IconButton>
                            <IconButton
                                disabled={!copiedPriceTable}
                                tooltip='Plak vervoerder tarieven'
                                onClick={this.onClickPasteCarrierPriceTable.bind(this, selectedCarrier)}
                            >
                                <i className='mdi mdi-content-paste' />
                            </IconButton>
                        </div>
                        <CarrierSelector
                            size={45}
                            carriers={enabledCarriers}
                            value={selectedCarrier.name}
                            onChange={this.onChangeCarrier.bind(this)}
                        />
                    </div>
                </FormStack>

                {(process.env.NODE_ENV !== 'production' || ['Veloyd', 'Groenbezorgen', 'Groenbezorgen Oss', 'Groenbezorgen Veghel'].includes(reseller.name)) &&
                    <>
                        <Toggle
                            style={{width: 280, marginBottom: 12}}
                            label='Tariefstaffels'
                            checked={priceTable[selectedCarrier.name]?.usePriceScales}
                            onChange={(event) => {
                                priceTable[selectedCarrier.name] = priceTable[selectedCarrier.name] || {usePriceScales: false}
                                priceTable[selectedCarrier.name].usePriceScales = event.target.checked
                                this.setState({priceTable})
                            }}
                        />

                        {priceTable[selectedCarrier.name]?.usePriceScales && <Alert style={{marginBottom: 6}} variant='info'>Wanneer zendingen onder een staffeltarief vallen wordt de prijs pas berekend op het moment van factureren.</Alert>}
                    </>
                }

                {selectedCarrierProducts.map((productName) => {
                    if (productName == 'Standaard zending' || (reseller.settings.parcels.products[productName] && reseller.settings.parcels.products[productName][selectedCarrier.name])) {
                        let product = selectedCarrier.products[productName]

                        if (productName == 'Standaard zending') {
                            product = {type: 'product', countries: selectedCarrier.countries}
                        }

                        return (
                            <Card shadow key={productName} style={{marginBottom: 36, padding: 12}}>
                                <S1 style={{marginBottom: 12}}>{productName}</S1>

                                {(process.env.NODE_ENV !== 'production' || ['Veloyd', 'Groenbezorgen', 'Groenbezorgen Oss', 'Groenbezorgen Veghel'].includes(reseller.name)) && priceTable[selectedCarrier.name]?.usePriceScales && product.type === 'product' &&
                                    <Toggle
                                        style={{width: 280 - 12, marginBottom: 12}}
                                        label='Tariefstaffels'
                                        checked={priceTable[selectedCarrier.name]?.[productName] && priceTable[selectedCarrier.name][productName].usePriceScales}
                                        onChange={(event) => {
                                            priceTable[selectedCarrier.name][productName] = priceTable[selectedCarrier.name][productName] || {usePriceScales: false}
                                            priceTable[selectedCarrier.name][productName].usePriceScales = event.target.checked
                                            // A new price rule or category starts with one empty tier, which gets the price that was filled in so far
                                            const isUntouched = (priceScales?: {price?: string, maxAmount?: number}[]) => !priceScales?.length || (priceScales.length === 1 && !priceScales[0].maxAmount && priceScales[0].price === '0,00')

                                            priceTable[selectedCarrier.name][productName].countryGroups?.forEach((priceRule) => {
                                                if (isUntouched(priceRule.priceScales)) {
                                                    priceRule.priceScales = [{
                                                        price: priceRule.price
                                                    }]
                                                }

                                                priceRule.categories.forEach((category) => {
                                                    if (isUntouched(category.priceScales)) {
                                                        category.priceScales = [{
                                                            price: category.price
                                                        }]
                                                    }
                                                })
                                            })
                                            this.setState({priceTable})
                                        }}
                                    />
                                }

                                {priceTable[selectedCarrier.name] && priceTable[selectedCarrier.name][productName] &&
                                    <SortableList
                                        dragHandle
                                        getId={indexId}
                                        // Block, like the list before: the items' bottom margins collapse with the spacing around it
                                        style={{display: 'block'}}
                                        items={priceTable[selectedCarrier.name][productName].countryGroups}
                                        renderItem={
                                            (priceRule: ParcelPriceRule, DragHandle, index) => {
                                                const priceScaleEnabled = priceTable[selectedCarrier.name]?.usePriceScales && priceTable[selectedCarrier.name][productName]?.usePriceScales

                                                return (
                                                    <div key={`${selectedCarrier.name}${productName}${index}`} style={{display: 'flex', columnGap: formSpacing.columnGap, marginLeft: 15, marginBottom: 12}}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            flexShrink: 0,
                                                            width: 279,
                                                            minWidth: 279,
                                                            height: 30
                                                        }}
                                                        >
                                                            <DragHandle />
                                                            <IconButton
                                                                onClick={this.onClickOpenPriceRuleModal.bind(this, selectedCarrier, productName, index, priceRule)}
                                                            >
                                                                <i className='mdi mdi-pencil' />
                                                            </IconButton>
                                                            <S2>{priceRule.name}</S2>
                                                        </div>

                                                        <div style={{display: 'flex', columnGap: formSpacing.columnGap}}>
                                                            <Select
                                                                style={{width: 150}}
                                                                value={priceRule.type}
                                                                onChange={this.onChangeType.bind(this, selectedCarrier, productName, index)}
                                                            >
                                                                {product.type === 'product' &&
                                                                    <option value='fixed'>Vaste prijs</option>
                                                                }

                                                                {product.type === 'product' &&
                                                                    <option value='weight'>Categorieën</option>
                                                                }

                                                                {product.type === 'product' &&
                                                                    <option value='fixedKg'>Kilo toeslag</option>
                                                                }

                                                                {product.type !== 'product' &&
                                                                    <option value='fee'>Toeslag</option>
                                                                }

                                                                {product.type !== 'product' &&
                                                                    <option value='feepercent'>Toeslag %</option>
                                                                }
                                                            </Select>

                                                            {priceRule.type === 'weight' && priceRule.categories.map((category, categoryIndex) => {
                                                                return (
                                                                    <FormStack
                                                                        key={categoryIndex}
                                                                        style={{
                                                                            width: 150,
                                                                            flexShrink: 0
                                                                        }}
                                                                    >
                                                                        {priceScaleEnabled ?
                                                                            (
                                                                                <Input
                                                                                    label=''
                                                                                    value={category.name || (category.maxWeight ? `t/m ${category.maxWeight} kg` : `Cat ${categoryIndex + 1}`)}
                                                                                    readOnly
                                                                                    append={
                                                                                        <IconButton
                                                                                            onClick={this.onClickOpenCategoryModal.bind(this, selectedCarrier, productName, index, categoryIndex, category)}
                                                                                        >
                                                                                            <i className='mdi mdi-pencil' />
                                                                                        </IconButton>
                                                                                    }
                                                                                />
                                                                            ) :
                                                                            <CurrencyInput
                                                                                label={category.name || (category.maxWeight ? `t/m ${category.maxWeight} kg` : `Cat ${categoryIndex + 1}`)}
                                                                                value={category.price}
                                                                                onChange={this.onChangeCategoryPrice.bind(this, selectedCarrier, productName, index, categoryIndex)}
                                                                                append={
                                                                                    <IconButton
                                                                                        onClick={this.onClickOpenCategoryModal.bind(this, selectedCarrier, productName, index, categoryIndex, category)}
                                                                                    >
                                                                                        <i className='mdi mdi-pencil' />
                                                                                    </IconButton>
                                                                                }
                                                                            />
                                                                        }
                                                                        {priceScaleEnabled &&
                                                                            <FormStack>
                                                                                {category.priceScales?.map((priceScale, i) => (
                                                                                    <CurrencyInput
                                                                                        key={i}
                                                                                        label={`${category.priceScales[i - 1]?.maxAmount + 1 || 0}${priceScale.maxAmount ? ` - ${priceScale.maxAmount} st` : '+ stuks'}`}
                                                                                        value={priceScale.price}
                                                                                        onChange={(event) => {
                                                                                            const priceScales = priceTable[selectedCarrier.name][productName].countryGroups[index].categories[categoryIndex].priceScales
                                                                                            if (priceScales?.[i]) {
                                                                                                priceScales[i].price = event.target.value
                                                                                            }
                                                                                            this.setState({priceTable})
                                                                                        }}
                                                                                        append={i !== (category.priceScales?.length - 1) ?
                                                                                            <IconButton
                                                                                                onClick={() => this.priceScaleModal.current?.open(
                                                                                                    selectedCarrier.name,
                                                                                                    productName,
                                                                                                    index,
                                                                                                    categoryIndex,
                                                                                                    i,
                                                                                                    priceRule.categories[categoryIndex].priceScales[i]
                                                                                                )}
                                                                                            >
                                                                                                <i className='mdi mdi-pencil' />
                                                                                            </IconButton> :
                                                                                            undefined
                                                                                        }
                                                                                    />
                                                                                ))}
                                                                                <Button
                                                                                    style={{width: '100%'}}
                                                                                    buttonStyle={{paddingLeft: 0, paddingRight: 0}}
                                                                                    label='Nieuwe staffel'
                                                                                    icon='mdi mdi-plus'
                                                                                    variant='outline'
                                                                                    onClick={() => this.priceScaleModal.current?.open(
                                                                                        selectedCarrier.name,
                                                                                        productName,
                                                                                        index,
                                                                                        categoryIndex,
                                                                                        null,
                                                                                        {
                                                                                            price: ''
                                                                                        }
                                                                                    )}
                                                                                />
                                                                            </FormStack>
                                                                        }
                                                                    </FormStack>
                                                                )
                                                            })}
                                                        </div>

                                                        {priceRule.type === 'weight' &&
                                                            <Button
                                                                style={{marginRight: 30}}
                                                                variant='outline'
                                                                icon='mdi mdi-plus'
                                                                label='Nieuwe categorie'
                                                                onClick={this.onClickAddCategory.bind(this, selectedCarrier, productName, index)}
                                                            />
                                                        }

                                                        {(priceRule.type === 'fixed' || priceRule.type === 'fixedKg' || priceRule.type === 'fee' || priceRule.type === 'feepercent') &&
                                                            <div style={{display: 'flex', width: 800, flexWrap: 'wrap', columnGap: formSpacing.columnGap, rowGap: formSpacing.rowGap}}>
                                                                {product.values ?
                                                                    product.values.map((value) => {
                                                                        return (
                                                                            <div
                                                                                key={value}
                                                                                style={{width: 150}}
                                                                            >
                                                                                {priceRule.type !== 'feepercent' &&
                                                                                    <CurrencyInput
                                                                                        label={`${productName === 'Verzekerd' ? 'Tot: ' : ''}${value}`}
                                                                                        value={priceRule.values[value]}
                                                                                        onChange={this.onChangePrice.bind(this, selectedCarrier, productName, index, value)}
                                                                                    />
                                                                                }

                                                                                {priceRule.type === 'feepercent' &&
                                                                                    <Input
                                                                                        label={`${productName === 'Verzekerd' ? 'Tot: ' : ''}${value}`}
                                                                                        value={priceRule.values[value]}
                                                                                        onChange={this.onChangePrice.bind(this, selectedCarrier, productName, index, value)}
                                                                                        append='%'
                                                                                    />
                                                                                }
                                                                            </div>
                                                                        )
                                                                    }) :
                                                                    <div style={{width: 150}}>
                                                                        {priceRule.type !== 'feepercent' &&
                                                                            <>
                                                                                {priceScaleEnabled ?
                                                                                    <FormStack>
                                                                                        {priceRule.priceScales?.map((priceScale, i) => (
                                                                                            <CurrencyInput
                                                                                                key={i}
                                                                                                label={`${priceRule.priceScales[i - 1]?.maxAmount + 1 || 0}${priceScale?.maxAmount ? ` - ${priceScale?.maxAmount} st` : '+ stuks'}`}
                                                                                                value={priceScale?.price}
                                                                                                onChange={(event) => {
                                                                                                    const priceScales = priceTable[selectedCarrier.name][productName].countryGroups[index].priceScales
                                                                                                    if (priceScales?.[i]) {
                                                                                                        priceScales[i].price = event.target.value
                                                                                                    }
                                                                                                    this.setState({priceTable})
                                                                                                }}
                                                                                                append={i !== (priceRule.priceScales?.length - 1) ?
                                                                                                    <IconButton
                                                                                                        onClick={() => this.priceScaleModal.current?.open(
                                                                                                            selectedCarrier.name,
                                                                                                            productName,
                                                                                                            index,
                                                                                                            null,
                                                                                                            i,
                                                                                                            priceRule.priceScales[i]
                                                                                                        )}
                                                                                                    >
                                                                                                        <i className='mdi mdi-pencil' />
                                                                                                    </IconButton> :
                                                                                                    undefined
                                                                                                }
                                                                                            />
                                                                                        ))}
                                                                                        <Button
                                                                                            style={{width: '100%'}}
                                                                                            buttonStyle={{paddingLeft: 0, paddingRight: 0}}
                                                                                            label='Nieuwe staffel'
                                                                                            icon='mdi mdi-plus'
                                                                                            variant='outline'
                                                                                            onClick={() => this.priceScaleModal.current?.open(
                                                                                                selectedCarrier.name,
                                                                                                productName,
                                                                                                index,
                                                                                                null,
                                                                                                null,
                                                                                                {
                                                                                                    price: ''
                                                                                                }
                                                                                            )}
                                                                                        />
                                                                                    </FormStack> :
                                                                                    <CurrencyInput
                                                                                        label='Prijs'
                                                                                        value={priceRule.price}
                                                                                        onChange={this.onChangePrice.bind(this, selectedCarrier, productName, index, null)}
                                                                                    />
                                                                                }
                                                                            </>
                                                                        }
                                                                        {priceRule.type === 'feepercent' &&
                                                                            <Input
                                                                                label='Percentage'
                                                                                value={priceRule.price}
                                                                                onChange={this.onChangePrice.bind(this, selectedCarrier, productName, index, null)}
                                                                                append='%'
                                                                            />
                                                                        }
                                                                    </div>
                                                                }

                                                                {priceRule.type === 'fixedKg' &&
                                                                    <CurrencyInput
                                                                        style={{width: 150}}
                                                                        label='Toeslag'
                                                                        value={priceRule.fee}
                                                                        onChange={this.onChangeFee.bind(this, selectedCarrier, productName, index)}
                                                                    />
                                                                }

                                                                {priceRule.type === 'fixedKg' &&
                                                                    <Select
                                                                        style={{width: 150}}
                                                                        label='Afronden op'
                                                                        options={[
                                                                            {title: 'kg', value: ''},
                                                                            {title: '100g', value: '100g'},
                                                                            {title: 'g', value: 'g'}
                                                                        ]}
                                                                        value={priceRule.round}
                                                                        onChange={this.onChangeRound.bind(this, selectedCarrier, productName, index)}
                                                                    />
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            }}
                                        onChange={this.onSortPricesRules.bind(this, selectedCarrier, productName)}
                                    />
                                }

                                <Button
                                    variant='outline'
                                    style={{marginBottom: 24, width: 'fit-content'}}
                                    icon='mdi mdi-plus'
                                    label='Nieuwe landengroep'
                                    onClick={this.onClickAddPriceRule.bind(this, selectedCarrier, product, productName)}
                                />
                            </Card>
                        )
                    }
                })}

                <br />
                {error && <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>}

                <ModalActions>
                    {oldName && oldName !== 'Standaard' &&
                        <Button onClick={this.onRemove.bind(this)}>Verwijder</Button>
                    }
                    <Button variant='text' onClick={this.close.bind(this, true)}>Annuleer</Button>
                    <Button variant='text' disabled={!name} onClick={this.onSubmit.bind(this)}>Opslaan</Button>
                </ModalActions>

                <PriceRuleModal
                    onChange={this.onEditPriceRule.bind(this)}
                    remove={this.onRemovePriceRule.bind(this)}
                    ref={(ref) => this.PriceRuleModal = ref}
                />

                <CategoryModal
                    onChange={this.onEditCategory.bind(this)}
                    remove={this.onRemoveCategory.bind(this)}
                    ref={(ref) => this.categoryModal = ref}
                />

                <PriceScaleModal
                    onSubmit={(carrierName, productName, countryGroupIndex, categoryIndex, scaleIndex, scale) => {
                        const priceScales = typeof categoryIndex === 'number' ? priceTable[carrierName][productName].countryGroups[countryGroupIndex].categories[categoryIndex].priceScales : priceTable[carrierName][productName].countryGroups[countryGroupIndex].priceScales

                        if (typeof scaleIndex === 'number') {
                            priceScales[scaleIndex] = scale
                        } else {
                            priceScales.push(scale)
                        }

                        // Make sure there is always a scale without a maxAmount (minAmount: x+)
                        const scalesWithMaxAmount = priceScales.filter((scale) => typeof scale?.maxAmount === 'number')
                        const sortedPriceScales = scalesWithMaxAmount.toSorted((a, b) => a.maxAmount - b.maxAmount)

                        const highestScale = priceScales.find((scale) => typeof scale?.maxAmount === 'undefined')
                        sortedPriceScales.push(highestScale)

                        sortedPriceScales.forEach((priceScale, index) => {
                            const sameMaxAmountIndex = sortedPriceScales.findIndex((p, i) => p.maxAmount === priceScale.maxAmount && index !== i)
                            if (sameMaxAmountIndex > -1) {
                                sortedPriceScales[sameMaxAmountIndex].maxAmount = sortedPriceScales[sameMaxAmountIndex].maxAmount + 1
                            }
                        })

                        if (typeof categoryIndex === 'number') {
                            priceTable[carrierName][productName].countryGroups[countryGroupIndex].categories[categoryIndex].priceScales = sortedPriceScales
                        } else {
                            priceTable[carrierName][productName].countryGroups[countryGroupIndex].priceScales = sortedPriceScales
                        }

                        this.setState({priceTable}, () => {
                            this.priceScaleModal.current?.close()
                        })
                    }}
                    onRemove={(carrierName, productName, countryGroupIndex, categoryIndex, scaleIndex) => {
                        const priceScales = typeof categoryIndex === 'number' ? priceTable[carrierName][productName].countryGroups[countryGroupIndex].categories[categoryIndex].priceScales : priceTable[carrierName][productName].countryGroups[countryGroupIndex].priceScales
                        priceScales.splice(scaleIndex, 1)

                        this.setState({priceTable}, () => {
                            this.priceScaleModal.current?.close()
                        })
                    }}
                    ref={this.priceScaleModal}
                />

                <Popup
                    ref={(ref) => this.popup = ref}
                    cancelLabel='Terug'
                    confirmLabel='Verwijderen'
                />
            </Modal>
        )
    }
}

export default PriceTableModal
